import React from 'react';
import cn from '@/utils/cn';
import { iconVariant, TIconColor } from './iconVariant';
import { IconProps } from './types/IconInterface';

interface UserGroupProps extends IconProps {
  color?: TIconColor;
}

/**
 * Heroicons mini "user-group" (16x16) - the exact glyph Figma uses for the sidebar's Team
 * members nav item. Not the same asset as Icons/Team.tsx, which renders a static, fixed-colour
 * <img> (src/assets/UserGroup.svg, heroicons/20/solid) that can't pick up the active/inactive
 * currentColor swap SideNavMenuItem relies on - this one uses fill="currentColor" throughout
 * (the source SVG hardcodes #11E8C2 per path instead) so it recolors correctly there.
 */
const UserGroup = ({ size, variant, className, color = 'white' }: UserGroupProps) => (
  <svg
    className={cn(iconVariant({ size, variant, iconColor: color, className }))}
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16">
    <path
      d="M7.99999 7.19999C9.32547 7.19999 10.4 6.12548 10.4 4.79999C10.4 3.47451 9.32547 2.39999 7.99999 2.39999C6.6745 2.39999 5.59999 3.47451 5.59999 4.79999C5.59999 6.12548 6.6745 7.19999 7.99999 7.19999Z"
      fill="currentColor"
    />
    <path
      d="M4.79999 6.39999C4.79999 7.28365 4.08364 7.99999 3.19999 7.99999C2.31633 7.99999 1.59999 7.28365 1.59999 6.39999C1.59999 5.51634 2.31633 4.79999 3.19999 4.79999C4.08364 4.79999 4.79999 5.51634 4.79999 6.39999Z"
      fill="currentColor"
    />
    <path
      d="M1.1925 12.2605C1.05684 12.1817 0.952158 12.0574 0.905962 11.9075C0.837073 11.6838 0.799988 11.4462 0.799988 11.2C0.799988 9.87451 1.8745 8.79999 3.19999 8.79999C3.61759 8.79999 4.01028 8.90665 4.35231 9.09421C3.51462 9.91908 2.9553 11.026 2.82782 12.2614C2.80943 12.4395 2.8171 12.6153 2.84796 12.7847C2.24847 12.7324 1.68688 12.5479 1.1925 12.2605Z"
      fill="currentColor"
    />
    <path
      d="M13.1524 12.7847C13.7517 12.7324 14.3132 12.5479 14.8075 12.2605C14.9431 12.1817 15.0478 12.0574 15.094 11.9075C15.1629 11.6838 15.2 11.4462 15.2 11.2C15.2 9.87451 14.1255 8.79999 12.8 8.79999C12.3825 8.79999 11.9899 8.9066 11.6479 9.09409C12.4856 9.91897 13.045 11.026 13.1725 12.2614C13.1909 12.4395 13.1832 12.6153 13.1524 12.7847Z"
      fill="currentColor"
    />
    <path
      d="M14.4 6.39999C14.4 7.28365 13.6836 7.99999 12.8 7.99999C11.9163 7.99999 11.2 7.28365 11.2 6.39999C11.2 5.51634 11.9163 4.79999 12.8 4.79999C13.6836 4.79999 14.4 5.51634 14.4 6.39999Z"
      fill="currentColor"
    />
    <path
      d="M4.24305 12.9527C4.08377 12.8085 3.99936 12.5983 4.02142 12.3845C4.22924 10.3706 5.93125 8.79999 8.0001 8.79999C10.069 8.79999 11.771 10.3706 11.9788 12.3845C12.0008 12.5983 11.9164 12.8085 11.7572 12.9527C10.7636 13.8521 9.44584 14.4 8.00011 14.4C6.55437 14.4 5.23659 13.8521 4.24305 12.9527Z"
      fill="currentColor"
    />
  </svg>
);

export default UserGroup;
